<template>
    <div class="statistics">
        <el-row>
            <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <el-card shadow="hover" class="cardItem">
                    <div class="cardTitle">
                        <div class="title">公司总人数</div>
                        <el-tooltip content="公司总人数" placement="top">
                            <i class="el-icon-warning-outline icon"></i>
                        </el-tooltip>
                    </div>

                    <div class="totalNum">{{ analy1.total }}</div>
                    <div style="height: 24px">
                        <el-progress :percentage="percent"></el-progress>
                    </div>
                    <!-- <div class="content">
                        <div>
              月同比: {{ analy1.yoy_growth?analy1.yoy_growth.toFixed(2):0 }}%
              <i class="el-icon-caret-top"
                 style="color:#ff0000"
                 v-show="analy1.yoy_growth > 0"></i>
              <i class="el-icon-caret-bottom"
                 style="color:#00A600"
                 v-show="analy1.yoy_growth < 0"></i>
            </div> 
                    </div>-->
                    <div class="footer">
                        <!-- 试用期员工：{{ analy2.period_num }} -->
                        {{ this.year }}年目标总人数：{{ analy4.target_number }}
                    </div>
                </el-card>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <el-card shadow="hover" class="cardItem">
                    <div class="cardTitle">
                        <div class="title">正式职员</div>
                        <el-tooltip content="正式职员" placement="top">
                            <i class="el-icon-warning-outline icon"></i>
                        </el-tooltip>
                    </div>
                    <div class="totalNum">{{ analy2.official_num }}</div>
                    <div class="content"></div>
                    <div class="footer">
                        本月入职人数：{{ analy1.this_month }}
                    </div>
                </el-card>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <el-card shadow="hover" class="cardItem">
                    <div class="cardTitle">
                        <div class="title">离职职员数</div>
                        <el-tooltip content="离职职员数" placement="top">
                            <i class="el-icon-warning-outline icon"></i>
                        </el-tooltip>
                    </div>

                    <div class="totalNum">{{ analy3.total }}</div>
                    <div class="content">
                        <div>
                            月同比:
                            {{
                                analy3.yoy_growth
                                    ? analy3.yoy_growth.toFixed(2)
                                    : 0
                            }}%
                            <i
                                class="el-icon-caret-top"
                                style="color: #ff0000"
                                v-show="analy3.yoy_growth > 0"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                style="color: #00a600"
                                v-show="analy3.yoy_growth < 0"
                            ></i>
                        </div>
                    </div>
                    <div class="footer">
                        本月离职人数：{{ analy3.this_month }}
                    </div>
                </el-card>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <el-card shadow="hover" class="cardItem">
                    <div class="cardTitle">
                        <div class="title">本月考勤率</div>
                        <el-tooltip
                            :content="`${this.year}年目标总人数`"
                            placement="top"
                        >
                            <i class="el-icon-warning-outline icon"></i>
                        </el-tooltip>
                    </div>

                    <div class="totalNum">{{ analy4.target_number }}</div>
                    <div style="height: 24px">
                        <!-- <el-progress :percentage="percent"></el-progress> -->
                    </div>

                    <div class="footer"><!-- 本年同比：{{ analy4.yoy_growth }}% -->本月考勤人数：</div>
                </el-card>
            </el-col>
            <el-col :span="24">
                <div class="tabsCont">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="部门人数统计" name="first">
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
                <div class="echart-wrap">
                    <v-chart
                        :auto-resize="true"
                        :options="barOption"
                        ref="eleBar"
                        theme="ovilia-green"
                    />
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
                <div class="tiantiCont">
                    <div class="tiantiTitle">部门负责人</div>
                    <el-scrollbar style="height: 100%">
                        <div
                            class="tiantiItem"
                            v-for="(item, index) in principalData"
                            :key="index"
                        >
                            <div class="itemIndex2">
                                {{ index + 1 }}
                            </div>
                            <div class="itemName">{{ item.name }}</div>
                            <div class="itemNum">
                                {{ item.manager }}
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div class="tabsCont">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="男女比例统计" name="first">
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div class="tabsCont">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="学历比例统计" name="first">
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div class="echart-wrap">
                    <v-chart
                        :auto-resize="true"
                        :options="sexPieOption"
                        ref="sexPie"
                        theme="ovilia-green"
                    />
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div class="echart-wrap">
                    <v-chart
                        :auto-resize="true"
                        :options="schoolPieOption"
                        ref="schoolPie"
                        theme="ovilia-green"
                    />
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import * as oaApi from "@/http/oaApi.js";
export default {
    data() {
        return {
            analy1: "",
            analy2: "",
            analy3: "",
            analy4: "",
            activeName: "first",
            xAxis: [],
            yAxis: [],
            principalData: [],
            analy6: "",
            analy7: "",
            year: new Date().getFullYear(),
        };
    },
    methods: {
        // tab切换
        handleClick(tab) {
            this.activeName = tab.name;
        },
        /**
         * 人事统计数据获取
         */
        getStatistics() {
            oaApi.userStatistics({}, "get").then((res) => {
                if (res) {
                    this.analy1 = res.data.analy1;
                    this.analy2 = res.data.analy2;
                    this.analy3 = res.data.analy3;
                    this.analy4 = res.data.analy4;
                    let analy5 = res.data.analy5;
                    for (let i = 0; i < analy5.length; i++) {
                        this.xAxis.push(analy5[i].name);
                        this.yAxis.push(analy5[i].user_num);
                        this.principalData.push({
                            name: analy5[i].name,
                            manager: analy5[i].manager,
                        });
                    }
                    this.analy6 = [
                        { value: res.data.analy6.man, name: "男" },
                        { value: res.data.analy6.woman, name: "女" },
                    ];
                    this.analy7 = [
                        { value: res.data.analy7.edu0, name: "博士" },
                        { value: res.data.analy7.edu1, name: "硕士" },
                        { value: res.data.analy7.edu2, name: "本科" },
                        { value: res.data.analy7.edu3, name: "大专" },
                        { value: res.data.analy7.edu4, name: "中专" },
                        { value: res.data.analy7.edu5, name: "高中" },
                        { value: res.data.analy7.edu6, name: "中学" },
                        { value: res.data.analy7.edu7, name: "小学" },
                    ];
                }
            });
        },
    },
    created() {
        this.getStatistics();
    },
    computed: {
        barOption() {
            const options = {
                grid: {
                    left: "5%",
                    right: "5%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "axis",
                },
                color: ["#eb5202"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "公司",
                        data: this.xAxis,

                        axisLabel: {
                            interval: 0,
                            rotate: 40,
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "（个）",
                    },
                ],
                series: [
                    {
                        name: "人数",
                        type: "bar",
                        barWidth: "40%",
                        data: this.yAxis,
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true, //开启显示
                                    position: "top", //在上方显示
                                    textStyle: {
                                        //数值样式
                                        color: "black",
                                        fontSize: 10,
                                    },
                                },
                            },
                        },
                    },
                ],
            };
            return options;
        },
        sexPieOption() {
            const options = {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                    transitionDuration: 0,
                },
                color: [
                    "#eb5202",
                    "#ba55d3",
                    "#ff69b4",

                    "#cd5c5c",
                    "#ffa500",
                    "#40e0d0",

                    "#1e90ff",
                    "#ff6347",
                    "#7b68ee",
                    "#00fa9a",
                    "#ffd700",

                    "#6699FF",
                    "#ff6666",
                    "#3cb371",
                    "#b8860b",
                    "#30e0e0",
                ],
                legend: {
                    orient: "vertical",
                    top: "30px",
                    left: "30px",
                    data: ["男", "女"],
                },
                series: [
                    {
                        name: "男女比例统计",
                        type: "pie",
                        radius: "50%",
                        center: ["40%", "40%"],
                        data: this.analy6,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };
            return options;
        },
        schoolPieOption() {
            const options = {
                // title: {
                //   text: '某站点用户访问来源',//主标题
                //   subtext: '纯属虚构',//副标题
                //   x: 'center',//x轴方向对齐方式
                // },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                    transitionDuration: 0,
                },
                color: [
                    "#eb5202",
                    "#ff69b4",
                    "#ba55d3",
                    "#cd5c5c",
                    "#ffa500",
                    "#40e0d0",

                    "#1e90ff",
                    "#ff6347",
                    "#7b68ee",
                    "#00fa9a",
                    "#ffd700",

                    "#6699FF",
                    "#ff6666",
                    "#3cb371",
                    "#b8860b",
                    "#30e0e0",
                ],
                legend: {
                    orient: "vertical",
                    top: "30px",
                    left: "30px",
                    data: [
                        "博士",
                        "硕士",
                        "本科",
                        "大专",
                        "中专",
                        "高中",
                        "初中",
                        "小学",
                    ],
                },
                series: [
                    {
                        name: "学历统计",
                        type: "pie",
                        radius: "50%",
                        center: ["50%", "40%"],
                        data: this.analy7,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };
            return options;
        },
        /**
         * 百分比
         */
        percent() {
            return Math.floor(
                (this.analy1.total / this.analy4.target_number) * 100
            );
        },
    },
};
</script>
<style lang="scss">
.statistics {
    width: 100%;
    min-height: 100%;
    background: #fff;
    box-sizing: border-box;
    overflow-x: hidden;
    .cardItem {
        margin: 10px;
        .el-card__body{
                        padding-bottom: 14px;

        }
        .cardTitle {
            display: flex;
            justify-content: space-between;
            font-size: 14px !important;
            line-height: 22px;
            color: rgba(0, 0, 0, 0.5);
        }
        .totalNum {
            width: 100%;
            font-size: 30px !important;
            line-height: 38px;
            margin-top: 4px;
            text-align: left;
        }
        .content {
            text-align: left;
            width: 100%;
            display: flex;
            justify-content: space-between;
            min-height: 24px;
            div {
                font-size: 12px;
                line-height: 2;
                width: 50%;
            }
        }
        .footer {
            border-top: 1px solid #e8e8e8;
            font-size: 12px;
            line-height: 1.5;
            text-align: left;
            padding-top: 14px;
            margin-top: 8px;
        }
    }
    .tabsCont {
        // margin-top: 20px;
        // width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        // .timeBtnGroup {
        //     display: flex;
        //     justify-content: space-between;
        //     border-bottom: 2px #e4e7ed solid;
        //     height: 38px;
        // }
    }
    // .contentCont {
    // display: flex;
    // width: 100%;

    .echart-wrap {
        width: 100%;
        margin-top: 20px;
        .echarts {
            width: 100%;
        }
    }
    .tiantiCont {
        width: 100%;
        margin-top: 20px;
        height: 350px;
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }
        .tiantiTitle {
            font-size: 14px;
            line-height: 1.2;
            font-weight: 500;
            text-align: left;
            margin-bottom: 6px;
        }
        .tiantiItem {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 8px 20px 8px 4px;
            box-sizing: border-box;
            font-size: 13px;
            /* &:hover {
                background: rgba(0, 0, 0, 0.1);
                cursor: pointer;
            } */
            .itemIndex1 {
                width: 18px;
                height: 18px;
                text-align: center;
                line-height: 18px;
                background: $theme-color;
                border-radius: 9px;
                color: #fff;
                font-size: 12px;
            }
            .itemIndex2 {
                width: 18px;
                height: 18px;
                text-align: center;
                line-height: 18px;
                background: #f5f5f5;
                border-radius: 9px;
                color: $theme-color;
                font-size: 12px;
            }
            .itemName {
                line-height: 1.2;
                width: calc(100% - 18px - 200px);
                text-align: left;
                text-indent: 20px;
            }
            .itemNum {
                width: 200px;
                text-align: right;
                line-height: 1.2;
            }
        }
    }
}
</style>
